import script from "./QModalActsVisit.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalActsVisit.vue?vue&type=script&setup=true&lang=js"

import "./QModalActsVisit.vue?vue&type=style&index=0&id=e72d71c0&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e72d71c0"]])

export default __exports__